export const IFRAME_POST_MESSAGE = {
  youtube: {
    pause: '{"event":"command","func":"pauseVideo","args":""}',
  },
  vimeo: {
    pause: '{"method":"pause"}',
  },
  dailymotion: {
    pause: '{"command":"pause"}',
  },
};
